import {mock} from './index';

export default {
  edgeUserOrganCreateAndJoin: () => mock('/edge/user/organization/createAndJoin'),
  edgeUserStructureCreateAndJoin: () => mock('/edge/user/structure/createAndJoin'),
  edgePasswordReset: () => mock('/edge/password/reset'),
  edgeOrganizationAdminCreateAndSet: () => mock('/edge/organization/admin/createAndSet')
};
